import 'regenerator-runtime/runtime';
import {MobiusClient} from "@mobiusjs/site-client";

const state = window.currentState,
    auth = state.auth,
    routes = state.routes,
    isLocal = routes.local,
    project = routes.project

const client = MobiusClient(__dirname)
let config = require('../config' + (isLocal ? ".local" : "")).default

config.theme = require('./config' + (isLocal ? ".local" : "")).default
client.setConfig(config);

client.setPlugins({
    site: require("@mobiusjs/giftcard-site-client").default
})

client.run()

